// Currency
import accounting from 'accounting'

let _teamCurrency = 'EUR'
let _teamSymbol = '€'
let _dutchFormat = true
let _usFormat = false

function _setCurrency (currency) {
  if (currency === 'EUR' || currency === 'GBP' || currency === 'USD') {
    _teamCurrency = currency

    _teamSymbol = '€'
    if (currency === 'GBP') {
      _teamSymbol = '£'
    } else if (currency === 'USD') {
      _teamSymbol = '$'
    }
  }
}

function _getCurrency () {
  return _teamCurrency
}

function _setCountryFormat (country) {
  if (country === 'US') {
    _usFormat = true
    _dutchFormat = false
  } else if (country !== 'UK') {
    _dutchFormat = true
  } else {
    _dutchFormat = false
  }
}

function _isDutchFormat () {
  return _dutchFormat
}

function _isUsFormat () {
  return _usFormat
}

function _format (priceVal) {
  const price = parseFloat(priceVal)
  if (_isDutchFormat()) {
    return accounting.formatMoney(price, '', 2, '.', ',')
  }

  return accounting.formatMoney(price, '', 2, ',', '.')
}

function _formatForInput (priceVal, bShowDecimal) {
  const price = parseFloat(priceVal)

  let val = ''
  if (_isDutchFormat()) {
    val = accounting.formatMoney(price, '', 2, '', ',')
    return bShowDecimal ? val : val.replace(',00', '')
  }

  val = accounting.formatMoney(price, '', 2, '', '.')
  return bShowDecimal ? val : val.replace('.00', '')
}

function _formatForInputNumber (numVal) {
  const price = parseFloat(numVal)

  let val = ''
  if (_isDutchFormat()) {
    val = accounting.formatMoney(price, '', 1, '', ',')
    return val.replace(',0', '')
  }

  val = accounting.formatMoney(price, '', 1, '', '.')
  return val.replace('.0', '')
}

function _formatForInputTax (numVal) {
  const price = parseFloat(numVal)

  let val = ''
  if (_isDutchFormat()) {
    val = accounting.formatMoney(price, '', 3, '', ',')
    return val.replace(',000', '')
  }

  val = accounting.formatMoney(price, '', 3, '', '.')
  return val.replace('.000', '')
}

function _convertToFloat (value) {
  if (_isDutchFormat()) {
    return _convertEuroToFloat(value)
  }

  return _convertUsdToFloat(value)
}

function _formatSymbol (priceVal) {
  const currency = _symbol()
  const price = parseFloat(priceVal)

  if (_isDutchFormat()) {
    return accounting.formatMoney(price, `${currency} `, 2, '.', ',')
  }

  return accounting.formatMoney(price, `${currency} `, 2, ',', '.')
}

function _symbol () {
  return _teamSymbol
}

function _convertEuroToFloat (value) {
  if (value !== undefined && value !== '') {
    let val = value.toString()
    let bNegative = false
    if (val.indexOf('-') === 0) {
      bNegative = true
      val = val.substr(1)
    }

    val = val.replace(/,/g, '~')
    val = val.replace(/~/g, '.')

    if (bNegative) {
      if (val !== '' && isNaN(parseFloat(val))) {
        return false
      }

      val = `-${val}`
    } else if (val !== '') {
      val = val < 1 ? parseFloat(val) : val
      if (isNaN(val)) {
        return false
      }
    }

    return val
  }

  return 0
}

function _convertUsdToFloat (value) {
  if (value !== undefined && value !== '') {
    let val = value.toString()
    let bNegative = false
    if (val.indexOf('-') === 0) {
      bNegative = true
      val = val.substr(1)
    }

    val = val.replace(/,/g, '')

    if (bNegative) {
      if (val !== '' && isNaN(parseFloat(val))) {
        return false
      }

      val = `-${val}`
    } else if (val !== '') {
      val = val < 1 ? parseFloat(val) : val
      if (isNaN(val)) {
        return false
      }
    }

    return val
  }

  return 0
}

function _round (price, decimal = 2) {
  return parseFloat(accounting.formatMoney(price, '', decimal, '', '.'))
}

const currency = {}
currency.setCurrency = _setCurrency
currency.getCurrency = _getCurrency
currency.isDutchFormat = _isDutchFormat
currency.setCountryFormat = _setCountryFormat
currency.isUsFormat = _isUsFormat

currency.format = _format
currency.formatSymbol = _formatSymbol
currency.formatForInput = _formatForInput
currency.formatForInputNumber = _formatForInputNumber
currency.formatForInputTax = _formatForInputTax
currency.symbol = _symbol
currency.convertToFloat = _convertToFloat
currency.round = _round

export default currency
